export default __webpack_public_path__ + "static/media/vi_VN.bca07c79.svg";